import { cookieStorage } from '@muse-web/storages'

const SEO_TEST_COOKIE_NAME = 'seo_test'
const SEO_TEST_ON = '1'

export type TNavigationMode = 'soft' | 'hard'

const isSeoTestTraffic = (): boolean => cookieStorage.get(SEO_TEST_COOKIE_NAME) === SEO_TEST_ON

export const getNavigationMode = (): TNavigationMode => (isSeoTestTraffic() ? 'hard' : 'soft')
